import { useEffect, useRef, useState } from 'react';
import logo from './logo.jpg';
import './App.css';

const ZOOM_LEVELS = ['', 'a11y-zoom-1', 'a11y-zoom-2'];
const ZOOM_PERCENTS = [100, 115, 130];
const STORAGE_KEY = 'yummythai-a11y-prefs';

const DEFAULT_PREFS = {
  zoomStep: 0,
  colorMode: 'normal',
  highlightLinks: false,
  highlightHeadings: false,
  readableFont: false,
  letterSpacing: false,
  lineHeight: false,
  stopAnimations: false,
  bigCursor: false,
  readingGuide: false,
};

function A11yOptionButton({ label, active, onClick, disabled }) {
  return (
    <button type="button" className="a11y-grid-btn" aria-pressed={active} onClick={onClick} disabled={disabled}>
      {label}
    </button>
  );
}

function App() {
const divStyle = {
    fontSize: '18px',
};

  const [panelOpen, setPanelOpen] = useState(false);
  const [prefs, setPrefs] = useState(DEFAULT_PREFS);
  // Guards the persist-effect below from writing the default prefs back over
  // a saved preference before the load-effect's setState has committed.
  const [prefsLoaded, setPrefsLoaded] = useState(false);
  const toggleButtonRef = useRef(null);
  const readingGuideRef = useRef(null);

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));
  const chooseColorMode = (mode) => setPrefs((p) => ({ ...p, colorMode: p.colorMode === mode ? 'normal' : mode }));

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (saved && typeof saved === 'object') {
        setPrefs((p) => ({ ...p, ...saved }));
      }
    } catch (e) {
      // ignore malformed/missing saved prefs
    }
    setPrefsLoaded(true);
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    html.classList.remove('a11y-zoom-1', 'a11y-zoom-2');
    const zoomCls = ZOOM_LEVELS[prefs.zoomStep];
    if (zoomCls) html.classList.add(zoomCls);

    html.classList.remove('a11y-grayscale', 'a11y-low-saturate', 'a11y-high-saturate');
    body.classList.toggle('a11y-contrast', prefs.colorMode === 'high-contrast');
    if (prefs.colorMode === 'grayscale') html.classList.add('a11y-grayscale');
    if (prefs.colorMode === 'low-saturation') html.classList.add('a11y-low-saturate');
    if (prefs.colorMode === 'high-saturation') html.classList.add('a11y-high-saturate');

    body.classList.toggle('a11y-highlight-links', prefs.highlightLinks);
    body.classList.toggle('a11y-highlight-headings', prefs.highlightHeadings);
    body.classList.toggle('a11y-readable-font', prefs.readableFont);
    body.classList.toggle('a11y-letter-spacing', prefs.letterSpacing);
    body.classList.toggle('a11y-line-height', prefs.lineHeight);
    html.classList.toggle('a11y-stop-motion', prefs.stopAnimations);
    html.classList.toggle('a11y-big-cursor', prefs.bigCursor);

    if (prefsLoaded) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    }
  }, [prefs, prefsLoaded]);

  useEffect(() => {
    if (!panelOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setPanelOpen(false);
        toggleButtonRef.current && toggleButtonRef.current.focus();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [panelOpen]);

  useEffect(() => {
    if (!prefs.readingGuide) return;
    const onMove = (e) => {
      if (readingGuideRef.current) {
        readingGuideRef.current.style.top = `${e.clientY - 22}px`;
      }
    };
    document.addEventListener('mousemove', onMove);
    return () => document.removeEventListener('mousemove', onMove);
  }, [prefs.readingGuide]);

  return (
      <div>
        <a href="#main-content" className="skip-link">Skip to content</a>
        <div className="nav-container">
            <div id="top"></div>
            <nav className="pb16 pb-xs-0">
                <div className="nav-utility bg-primary">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-4  text-center-xs">
                                <span className="sub">2961 Beachwood Dr,Merced,California,95348</span>
                            </div>
                            <div className="col-sm-4 text-center">
                                <ul className="list-inline social-list">
                                    <li>
                                        <a href="https://www.facebook.com/Yummy-Thai-100987675414175/" aria-label="Yummy Thai on Facebook">
                                            <i className="ti-facebook" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/mercedyummythai/" aria-label="Yummy Thai on Instagram">
                                            <i className="ti-instagram" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-sm-4 text-right text-center-xs">
                                <span className="sub">Open Wed-Mon: 10am - 8pm(Summer 9pm)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pt120 pb80 pt-xs-40 pb-xs-16">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <h1 className="sr-only">Merced Yummy Thai</h1>
                                <a href="index.html">
                                    <img alt="Yummy Thai logo" className="logo" src={logo} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="module widget-handle mobile-toggle text-center visible-xs">
                    <i className="ti-menu"></i>
                </div> */}
                <div className="nav-bar text-center">
                    <div className="container">
                        <div className="row">
                            <div className="text-center">
                                <ul className="menu inline-block mb-xs-16">
                                    <li className="top-link hidden-xs">
                                        <a href="#top" className="inner-link">
                                            <i className="ti-arrow-up"></i> Top</a>
                                    </li>
                                    <li>
                                        <a href="#about" className="inner-link" style={divStyle}>About</a>
                                    </li>
                                    <li>
                                        <a href="#menu" className="inner-link" style={divStyle}>Menu</a>
                                    </li>
                                    <li>
                                        <a href="#map" className="inner-link" style={divStyle}>Map</a>
                                    </li>
                                    <li>
                                        <a href="#contact" className="inner-link" style={divStyle}>Contact</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            
        </div>
        
        <main className="main-container" id="main-content">
            <section className="pb0 pt20">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <div className="image-slider slider-arrow-controls mb0">
                                <ul className="slides">
                                    <li>
                                        <img alt="Thai dishes served at Yummy Thai, including papaya salad, sticky rice, and Thai chicken wings in a blue bowl" src="img/home1.jpg" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="about"></div>
            <section className="pb0">
                <div className="container">
                    <div className="row  mb64 mb-xs-40">
                        <div className="col-sm-12 text-center">
                            <div className="section-label">
                                <h2 className="section-label-text">Yummy Thai</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mb64 mb-xs-40">
                        <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 text-center">
                            <h3>
                                Yummy Thai and Laos Food.
                            </h3>
                            <h3>
                                Available now in Merced.
                            </h3>
                        </div>
                    </div>
                </div>
            </section>
            <div id="menu"></div>
            <section className="pb0">
                <div className="container">
                    <div className="row  mb64 mb-xs-40">
                        <div className="col-sm-12 text-center">
                            <div className="section-label">
                                <h2 className="section-label-text">Menu</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="row">
                                <div className="menu center">
                                    <a href="https://yummythaimercedca.smiledining.com//?2022101701" target="_blank" rel="noopener noreferrer">
                                        <img src="img/restaurant-menu.png" alt="View the full Yummy Thai menu (opens in a new tab)"/>
                              
                                    </a>
                                </div>

                            
                        </div>
                    </div>
                </div>
            </section>
            <section className="pb0">
                <div className="container">
                    <div className="row">
                    <div className="col-sm-6 text-center">
                            <div className="image-slider slider-arrow-controls mb0">
                                <ul className="slides">
                                    <li>
                                        <img alt="A bowl of Thai boat noodle soup topped with fresh herbs and crispy shallots" src="img/body1.jpg" />
                                    </li>
                                </ul>
                            </div>
                    </div>
                    <div className="col-sm-6 text-center">
                            <div className="image-slider slider-arrow-controls mb0">
                                <ul className="slides">
                                    <li>
                                        <img alt="Thai chicken wings garnished with fresh herbs, served in a blue bowl" src="img/body2.jpg" />
                                    </li>
                                </ul>
                            </div>
                    </div>

                        
                    </div>
                </div>
            </section>

            <div id="map"></div>
            <section className="pb0" >
                <div className="container">
                    <div className="row  mb64 mb-xs-40">
                        <div className="col-sm-12 text-center">
                            <div className="section-label">
                                <h2 className="section-label-text">@mercedyummythai</h2>
                            </div>
                        </div>
                    </div>
                    <div className="map-holder pt120 pb120">
                        <iframe title="Map showing Yummy Thai location at 2961 Beachwood Dr, Merced, California" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3172.4853135870376!2d-120.5304368848665!3d37.33101757984269!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80916918a7d3f22f%3A0x6956dfa333103f3d!2sYummy%20Thai!5e0!3m2!1sen!2sus!4v1668492669817!5m2!1sen!2sus" width="600" height="450"  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            </div>
            </section>
            <div id="contact"></div>
            <section>
                <div className="container">
                    <div className="row  mb64 mb-xs-40">
                        <div className="col-sm-12 text-center">
                            <div className="section-label">
                                <h2 className="section-label-text">Contact</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="map-holder pt120 pb120">
                                <div className="col-md-6 col-md-offset-3 col-sm-10 col-sm-offset-1 contact-details">
                                    <div className="pt80 pb56 bg-white p32 overflow-hidden">
                                        <div className="col-sm-10 col-sm-offset-1">
                                            <p>
                                                <strong>Open Wed-Mon: 10am - 8pm(Summer 9pm)</strong>
                                                <br /> Drop by to eat yummy thai food,
                                                <br /> for larger groups call ahead to
                                                <br /> make a reservation.
                                            </p>
                                            <p>
                                                2961 Beachwood Dr,Merced
                                                <br /> California,95348
                                            </p>
                                            <p>
                                                Phone: (209) 230-0130

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer className="bg-primary pt120 pb120 pt-xs-40 pb-xs-64">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 mb-xs-24 text-center-xs">
                            <div className="inline-block display-block-xs text-center-xs">
                                <h3 className="h6 uppercase mb16">Merced Yummy Thai.</h3>
                                <span className="sub display-block">2961 Beachwood Dr,Merced,California,95348</span>
                                <span className="sub display-block">Open Wed-Mon: 10am - 8pm(Summer 9pm)</span>
                            </div>
                        </div>
                        <div className="col-md-3 col-md-offset-3 col-sm-4 col-sm-offset-2 text-center">
                            <h3 className="h6 uppercase">Follow Us</h3>
                            <ul className="list-inline social-list">
                                <li>
                                    <a href="https://www.facebook.com/Yummy-Thai-100987675414175/" target="_blank" rel="noopener noreferrer" aria-label="Yummy Thai on Facebook">
                                        <i className="ti-facebook" aria-hidden="true"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/mercedyummythai/" target="_blank" rel="noopener noreferrer" aria-label="Yummy Thai on Instagram">
                                        <i className="ti-instagram" aria-hidden="true"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </main>

        {prefs.readingGuide && <div ref={readingGuideRef} className="a11y-reading-guide-bar" aria-hidden="true"></div>}

        {panelOpen && (
            <div id="a11y-panel" role="dialog" aria-label="Accessibility menu" className="a11y-panel">
                <div className="a11y-panel-header">
                    <h2 className="a11y-panel-title">Accessibility menu</h2>
                    <div className="a11y-panel-header-actions">
                        <button type="button" className="a11y-icon-btn" aria-label="Reset all accessibility options" onClick={() => setPrefs(DEFAULT_PREFS)}>
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M3 12a9 9 0 1 0 3-6.7" />
                                <path d="M3 4v5h5" />
                            </svg>
                        </button>
                        <button type="button" className="a11y-icon-btn" aria-label="Close accessibility menu" onClick={() => { setPanelOpen(false); toggleButtonRef.current && toggleButtonRef.current.focus(); }}>
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                                <line x1="5" y1="5" x2="19" y2="19" />
                                <line x1="19" y1="5" x2="5" y2="19" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="a11y-panel-body">
                    <div className="a11y-panel-group">
                        <div className="a11y-panel-group-title">Text size</div>
                        <div className="a11y-zoom-row">
                            <button type="button" className="a11y-round-btn" aria-label="Decrease text size" onClick={() => setPrefs((p) => ({ ...p, zoomStep: Math.max(p.zoomStep - 1, 0) }))} disabled={prefs.zoomStep <= 0}>
                                −
                            </button>
                            <span aria-live="polite">{ZOOM_PERCENTS[prefs.zoomStep]}%</span>
                            <button type="button" className="a11y-round-btn" aria-label="Increase text size" onClick={() => setPrefs((p) => ({ ...p, zoomStep: Math.min(p.zoomStep + 1, ZOOM_LEVELS.length - 1) }))} disabled={prefs.zoomStep >= ZOOM_LEVELS.length - 1}>
                                +
                            </button>
                        </div>
                    </div>

                    <div className="a11y-panel-group">
                        <div className="a11y-panel-group-title">Content adjustments</div>
                        <div className="a11y-grid">
                            <A11yOptionButton label="Highlight links" active={prefs.highlightLinks} onClick={() => toggle('highlightLinks')} />
                            <A11yOptionButton label="Highlight headings" active={prefs.highlightHeadings} onClick={() => toggle('highlightHeadings')} />
                            <A11yOptionButton label="Readable font" active={prefs.readableFont} onClick={() => toggle('readableFont')} />
                            <A11yOptionButton label="Letter spacing" active={prefs.letterSpacing} onClick={() => toggle('letterSpacing')} />
                            <A11yOptionButton label="Line height" active={prefs.lineHeight} onClick={() => toggle('lineHeight')} />
                        </div>
                    </div>

                    <div className="a11y-panel-group">
                        <div className="a11y-panel-group-title">Color adjustments</div>
                        <div className="a11y-grid">
                            <A11yOptionButton label="High contrast" active={prefs.colorMode === 'high-contrast'} onClick={() => chooseColorMode('high-contrast')} />
                            <A11yOptionButton label="Grayscale" active={prefs.colorMode === 'grayscale'} onClick={() => chooseColorMode('grayscale')} />
                            <A11yOptionButton label="Low saturation" active={prefs.colorMode === 'low-saturation'} onClick={() => chooseColorMode('low-saturation')} />
                            <A11yOptionButton label="High saturation" active={prefs.colorMode === 'high-saturation'} onClick={() => chooseColorMode('high-saturation')} />
                        </div>
                    </div>

                    <div className="a11y-panel-group">
                        <div className="a11y-panel-group-title">Tools</div>
                        <div className="a11y-grid">
                            <A11yOptionButton label="Stop animations" active={prefs.stopAnimations} onClick={() => toggle('stopAnimations')} />
                            <A11yOptionButton label="Big cursor" active={prefs.bigCursor} onClick={() => toggle('bigCursor')} />
                            <A11yOptionButton label="Reading guide" active={prefs.readingGuide} onClick={() => toggle('readingGuide')} />
                        </div>
                    </div>
                </div>
            </div>
        )}
        <button
            type="button"
            ref={toggleButtonRef}
            className="a11y-toggle"
            aria-expanded={panelOpen}
            aria-controls="a11y-panel"
            aria-label="Accessibility options"
            onClick={() => setPanelOpen((o) => !o)}
        >
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <circle cx="12" cy="4.5" r="2" fill="#fff" stroke="none" />
                <line x1="12" y1="8" x2="12" y2="14" />
                <line x1="6" y1="10" x2="18" y2="10" />
                <line x1="12" y1="14" x2="7" y2="20" />
                <line x1="12" y1="14" x2="17" y2="20" />
            </svg>
        </button>
        </div>

  );
}

export default App;
